export default __webpack_public_path__ + "static/media/18-plus-age-gr.5d5a0134.svg";